import React, { useEffect } from "react";
import ComplianceHeader from "../ComplianceHeader.js";
import { Loader } from "semantic-ui-react";
import useComplianceView from "@hooks/useComplianceView.js";
import AgcCheckForm from "@common/components/shared/AgcCheckForm.js";
import useAgcCheckContainer from "@hooks/useAgcCheckContainer.js";
import useEventDetailsGrid from "../../../hooks/useEventDetailsGrid.js";

const AgcCheckContainer = () => {
  const { formLoading } = useComplianceView();
  const { loadRecord } = useAgcCheckContainer();
  const {
    activeRow: {
      agcCheck: { id },
    },
  } = useEventDetailsGrid();

  useEffect(loadRecord, [id]);

  if (formLoading) {
    return <Loader active />;
  }

  return (
    <>
      <ComplianceHeader title="AGC Check" loadRecord={loadRecord} />
      <AgcCheckForm />
    </>
  );
};

export default AgcCheckContainer;
